import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const AuctionTranscriptionReport = (props) => {

  // console.log('AuctionTranscriptReport', props)
  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        AuctionID={props.match?.params?.auctionID}
        auctionName={props.location.state?.auctionName}
        laneName={props.location.state?.laneName}
        laneID={props.location.state?.laneID}
      />
    </React.Fragment>
  );
};

export default observer(AuctionTranscriptionReport);
